module.exports = __webpack_public_path__ + "img/Fries Icon - charcoal.ed23fb1e.svg";